module.exports = __webpack_public_path__ + "static/media/yourSky.587ffce2.png";